import { restClient } from '../../client';

export type PatientIsMedicaidResponse = {
  data: boolean;
};

export const patientIsMedicaid = (userId: string) =>
  restClient.request<PatientIsMedicaidResponse>(`/api/v1/insurance/${userId}/medicaid`, { method: 'GET' });
